import React from 'react';
import { AppBar, Toolbar, Button, Box, useMediaQuery, useTheme, IconButton, Menu, MenuItem, Container } from '@mui/material';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LanguageSelector from './LanguageSelector';
import MenuIcon from '@mui/icons-material/Menu';

const Header: React.FC = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  const location = useLocation();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const langPrefix = location.pathname.match(/^\/(en|es|de)/)?.[1] || '';

  const localizePath = (path: string) => langPrefix ? `/${langPrefix}${path}` : path;

  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  return (
    <AppBar position="static">
      <Container maxWidth="xl">
        <Toolbar sx={{ justifyContent: 'space-between', px: { xs: 0, sm: 1 } }}>
          <Box 
            component={RouterLink} 
            to={localizePath('/')}
            sx={{ 
              display: 'flex', 
              alignItems: 'center', 
              textDecoration: 'none',
              mr: 2
            }}
          >
            <Box
              component="img"
              src="/images/xperience-tattoo-logo.png"
              alt={t('header.brand')}
              sx={{
                height: { xs: '16px', sm: '20px' },
                width: 'auto'
              }}
            />
          </Box>
          
          {isMobile ? (
            <>
              <Box sx={{ flexGrow: 1 }} />
              <LanguageSelector />
              <IconButton
                color="inherit"
                aria-label="menu"
                onClick={handleMenuOpen}
                edge="end"
                sx={{ ml: 1 }}
              >
                <MenuIcon />
              </IconButton>
              <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleMenuClose}
              >
                <MenuItem component={RouterLink} to={localizePath('/')} onClick={handleMenuClose}>
                  {t('header.home')}
                </MenuItem>
                <MenuItem component={RouterLink} to={localizePath('/experiences')} onClick={handleMenuClose}>
                  {t('header.experiences')}
                </MenuItem>
                <MenuItem component={RouterLink} to={localizePath('/about')} onClick={handleMenuClose}>
                  {t('header.about')}
                </MenuItem>
                <MenuItem component={RouterLink} to={localizePath('/contact')} onClick={handleMenuClose}>
                  {t('header.contact')}
                </MenuItem>
              </Menu>
            </>
          ) : (
            <>
              <Box sx={{ display: 'flex', alignItems: 'center', flexGrow: 1, justifyContent: 'center', gap: { xs: 1, sm: 2 } }}>
                <Button 
                  color="inherit" 
                  component={RouterLink} 
                  to={localizePath('/')}
                  sx={{ fontSize: { xs: '0.8rem', sm: '0.875rem' } }}
                >
                  {t('header.home')}
                </Button>
                <Button 
                  color="inherit" 
                  component={RouterLink} 
                  to={localizePath('/experiences')}
                  sx={{ fontSize: { xs: '0.8rem', sm: '0.875rem' } }}
                >
                  {t('header.experiences')}
                </Button>
                <Button 
                  color="inherit" 
                  component={RouterLink} 
                  to={localizePath('/about')}
                  sx={{ fontSize: { xs: '0.8rem', sm: '0.875rem' } }}
                >
                  {t('header.about')}
                </Button>
                <Button 
                  color="inherit" 
                  component={RouterLink} 
                  to={localizePath('/contact')}
                  sx={{ fontSize: { xs: '0.8rem', sm: '0.875rem' } }}
                >
                  {t('header.contact')}
                </Button>
              </Box>
              <Box sx={{ display: 'flex', justifyContent: 'flex-end', minWidth: 60 }}>
                <LanguageSelector />
              </Box>
            </>
          )}
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default Header;
